import { render } from "./Kpi.vue?vue&type=template&id=5439ada4&scoped=true"
import script from "./Kpi.vue?vue&type=script&lang=js"
export * from "./Kpi.vue?vue&type=script&lang=js"

import "./Kpi.vue?vue&type=style&index=0&id=5439ada4&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5439ada4"]])

export default __exports__